import { defineStore } from 'pinia';

export const buttonPinia = defineStore('buttonPinia', {
  state: () => {
    return {
      buttonInfo: []
    }
  },
  actions: {
    changeMenuButtonInfo(list) {
      return this.buttonInfo = list
    }
  }
})